enum ContentFeedAiGeneratedSkillToolName {
  UpdateContentFeedBrief = 'updateContentFeedBrief',
  AddOrUpdateFeedColumn = 'addOrUpdateFeedColumn',
  UpdateCreativeColumnGenerationSetup = 'updateCreativeColumnGenerationSetup',
  GetDraftItems = 'getDraftItems',
  CreateDraftItems = 'createDraftItems',
  UpdateDraftItems = 'updateDraftItems',
  DeleteDraftItems = 'deleteDraftItems',
}

export {ContentFeedAiGeneratedSkillToolName};
